import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { consume } from '@lit/context'
import { html, LitElement, nothing, type CSSResultGroup } from 'lit'
import { DeliveryMatchActionsContext, DeliveryMatchSelectedMethodContext, NO_SELECTED_METHOD, type DeliveryMatchActionsContextType, type DeliveryMatchSelectedMethodContextType } from './provider.js'
import { customElement, query, state } from 'lit/decorators.js'
import { style } from './delivery-match-continue-button.style.js'

@customElement('csc-delivery-match-continue-button')
export class CSCDeliveryMatchContinueButton extends LitElement {
  static override styles?: CSSResultGroup = [style]

  @consume({ context: DeliveryMatchSelectedMethodContext, subscribe: true })
  selectedMethod!: DeliveryMatchSelectedMethodContextType

  @consume({ context: DeliveryMatchActionsContext, subscribe: true })
  private actions!: DeliveryMatchActionsContextType

  @query('form')
  submitForm!: HTMLFormElement

  @state()
  isSubmitting = false

  private handleClick = async () => {
    if (this.selectedMethod === NO_SELECTED_METHOD) return

    this.isSubmitting = true

    const success = await this.actions.updateShipmentMethod()

    if (!success) {
      this.isSubmitting = false
      return
    }

    this.submitForm.requestSubmit()
  }

  override render() {
    return html`
      <div class="csc-delivery-match-continue-button">
        <form method="post" action="">
          <input name="action_shipping" hidden/>
        </form>
        <cse-button variant="primary" ?disabled="${this.isSubmitting || this.selectedMethod == NO_SELECTED_METHOD}" @click=${this.handleClick}>
          ${this.isSubmitting ? html`<cse-loader slot="prefix"></cse-loader>` : nothing}
          ${t('continue_text', { ns: 'csc-delivery-match', default: 'Continue' })}
        </cse-button>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-delivery-match-continue-button': CSCDeliveryMatchContinueButton
  }
}
